/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Badge_RightInputs */

const en_us2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R`)
};

const pt_br2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const es_419_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const pt_pt2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const fr_fr2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

const de_de2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`R`)
};

const it_it2_workout_logging_badge_right = /** @type {(inputs: Workout_Logging_Badge_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D`)
};

/**
* | output |
* | --- |
* | "R" |
*
* @param {Workout_Logging_Badge_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_badge_right = /** @type {((inputs?: Workout_Logging_Badge_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Badge_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_badge_right(inputs)
	if (locale === "es-419") return es_419_workout_logging_badge_right(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_badge_right(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_badge_right(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_badge_right(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_badge_right(inputs)
	return en_us2_workout_logging_badge_right(inputs)
});
export { workout_logging_badge_right as "workout-logging.badge_right" }